import { ChainId } from '@ui/types/chain';
import { getContract, PublicClient, WalletClient } from 'viem';

import VaultFacet from '../abis/VaultFacet';
import { getContractAddress } from '../constants';

export const getVaultFacet = ({
  publicClient,
  walletClient,
  chainId,
}: {
  publicClient: PublicClient;
  walletClient?: WalletClient;
  chainId: ChainId;
}) => {
  const address = getContractAddress('LeverUp', chainId);
  if (!address) throw new Error('Contract address not found');

  return getContract({
    abi: VaultFacet,
    address: address,
    client: {
      public: publicClient,
      wallet: walletClient,
    },
  });
};
